module.exports = __webpack_public_path__ + "static/PureLeafHerbalIce-d43248f49ac4e9ebbd29abed4ab1f2c2.jpg";